import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" {...this.props}><path fillRule="evenodd" fill="#007EE5" d="M14.5 5.164l5.97-5.177 8.531 5.788-5.9 4.907L14.5 5.164zM29.001 15.59l-8.531 5.788-5.97-5.177 8.601-5.519 5.9 4.908zm-20.47 5.788L0 15.59l5.899-4.908 8.601 5.519-5.969 5.177zM0 5.775L8.531-.013 14.5 5.164l-8.601 5.518L0 5.775zm14.518 11.54l5.987 5.161 2.562-1.737v1.948l-8.549 5.326-8.549-5.326v-1.948l2.562 1.737 5.987-5.161z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/dropbox.svg